export default __webpack_public_path__ + "static/media/WearAndTearProtection.91e9c5c8.webp";